import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-send\"><path fill-rule=\"evenodd\" d=\"M18.648 4.531 5.475 9.273l5.245 2.053a2 2 0 0 1 1.134 1.133l2.052 5.245 4.742-13.173Zm.922-2.458c.956-.344 1.88.58 1.536 1.536l-6.04 16.777c-.375 1.042-1.842 1.062-2.246.03l-2.83-7.227-7.227-2.829c-1.032-.404-1.012-1.872.03-2.247l16.777-6.04Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol